document.querySelectorAll('[data-bf-form]').forEach((form) => {
  const button = form.querySelector('button[type="submit"]');
  const label = form.querySelector('[data-bf-button-label]');
  const error = form.querySelector('[data-bf-error-message]');
  const success = form.parentElement.querySelector('[data-bf-success]');
  const returnLink = form.closest('.shopify-section').querySelector('[data-bf-return]');
  const originalLabel = label.textContent;
  let pending = false;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (pending || form.dataset.bfConfigured !== 'true' || !form.reportValidity()) return;

    pending = true;
    button.disabled = true;
    label.textContent = form.dataset.bfPending;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        credentials: 'omit',
        body: new URLSearchParams(new FormData(form)),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Subscription request failed');
      const result = await response.json();
      if (result.success !== true) throw new Error('Subscription was not accepted');

      form.hidden = true;
      success.hidden = false;
      if (returnLink) returnLink.hidden = true;
      success.focus();
    } catch {
      error.textContent = form.dataset.bfError;
      error.hidden = false;
    } finally {
      clearTimeout(timeout);
      pending = false;
      button.disabled = false;
      label.textContent = originalLabel;
      form.removeAttribute('aria-busy');
    }
  });

  button.disabled = form.dataset.bfConfigured !== 'true';
});
